<template>
  <v-app id="app" class="auth-layout">
    <v-main>
      <myHeader />

      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs10>
            <v-card>
              <v-card-title class="headline dark lighten-2" primary-title>
                {{ $t("global.privacy_policy_title") }}
              </v-card-title>

              <v-card-text class="py-5">
                <Component :is="currentLoadedContent" />
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import myHeader from "@/themes/partials/shared/HeaderAuth.vue"

export default {
  name: "privacy-statement-layout",

  components: {
    myHeader,
    "content-en": () =>
      import("@/themes/partials/shared/privacy_contents/content.en"),
    "content-no": () =>
      import("@/themes/partials/shared/privacy_contents/content.no"),
  },

  computed: {
    currentLoadedContent: function() {
      return "content-" + this.locale
    },
    locale: {
      get() {
        return this.$store.getters["settings/fe_locale"]
      },
      set(value) {
        this.$updateSetting("locale", value)
        this.$i18n.locale = value
      },
    },
  },
}
</script>
